<template>
  <b-overlay 
    :show="busy" 
  >
    <router-view 
      :relaties="relaties" 
      :units="units"
    />

    <b-pagination
      v-model="currentPage"
      :total-rows="docs.length"
      :per-page="30"
      small
      responsive="sm"
      prev-text="Vorige"
      next-text="Volgende"
      limit="15"
      align="left"
    >
      <template #page="{ page, active }">
        <span 
          v-if="active"
        >Pagina {{ page }} van {{ Math.ceil(docs.length / 30) }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>

    <b-table
      ref="table"
      :fields="fields"
      :items="docs"
      :current-page="currentPage"
      :per-page="30"
      :busy="isBusy"
      dark
      small
      select-mode="single"
      selectable
      selected-variant="info"
      hover
      bordered
      striped
      @row-clicked="selectDocument"
    >
      <template slot="table-busy">
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle" />
          <strong class="mx-2">Laden...</strong>
        </div>
      </template>

      <template #cell(Zi)="row">
        {{ row.item.Zi ? 'Ja' : 'Nee' }}
      </template>

      <template #cell(Da)="row">
        {{ moment(row.item.Da).format("DD.MM.YY") }}
      </template>

      <template #cell(Re)="row">
        {{ row.item.Re }}
      </template>

      <template #cell(Cl)="row">
        <i 
          v-show="row.item.Cl == 1" 
          class="fa fa-cloud"
        />
      </template>

      <template #cell(St)="row">
        <b-button 
          v-if="row.item.Ty == 'Keuring' && row.item.UnId != null" 
          :to="{name:'UnitViewRoute',params:{id:row.item.UnId}}"
          variant="primary" 
          class="btn-sm"
        >
          Zie unit
        </b-button>
        <span v-else>{{ row.item.St }}</span>
      </template>
      <template #cell(Ve)="row">
        {{ row.item.Ve ? moment(row.item.Ve).format("DD.MM.YY") : "nb" }}
      </template>

      <template #cell(Un)="row">
        <b-link :to="{name:'UnitViewRoute',params:{id:row.item.UnId}}">
          {{ row.item.Un }}
        </b-link>
      </template>
      <template #cell(actions)="row">
        <b-button 
          :to="{name:'Document',params:{id:row.item.Id}}" 
          size="sm"
        >
          Ga naar document
        </b-button>
      </template>
    </b-table>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";

export default {
  components: {
  },
  mixins: [ serviceMixin],
  props: {
    docs: {
      type: Array,
      default: () => []
    },
    isBusy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      relaties: [],
      units: [],
      fields: [
        "Id",
        { label: "Status", key: "St" },
        { label: "Relatie", key: "Re" },
        { label: "Afzender", key: "Af" },
        { label: "Kenmerk", key: "Ke" },
        { label: "Type", key: "Ty" },
        { label: "Datum", key: "Da" },
        { label: "Bedrag", key: "Be" },
        { label: "Verzenddatum", key: "Ve" },
        { label: "Soort onderhoud", key: "So" },
        { label: "Zichtbaar", key: "Zi" },
        { label: "Unit", key: "Un" },
        // { label: "Cloud", key: "Cl" },
        {label: "", key: "actions"}
      ],
      zoekVerwerkt: null,
      busy: false,
     currentPage: 1,
     
    };
  },
  methods: {
    selectDocument(item) {
      this.$router.push({ name: "Document", params: {id: item.Id }})
    },
  },
};
</script>